import { useEffect, useState } from "react"
import CompletedIcon from '../../../../assets/images/Completed.svg'
import UpNextIcon from '../../../../assets/images/Up Next.svg'
import NotStartedIcon from '../../../../assets/images/Not Started.svg'
import NA from '../../../../assets/images/NA.svg'
import DelayedIcon from '../../../../assets/images/Delayed.svg'
import pendingIcon from '../../../../assets/images/Pending.svg'
import { CONSTANTS } from "client/utils/constants"
import Moment from 'moment';
import { LoadingWrapper } from "client/CommonComponents"

const Task = (props?: any) => {
    const {
        assetItemStatusTemp,
        isLoading
    }: any = props;

    const [assetItemStatusTaskDetailTemp, setAssetItemStatusTaskDetail] = useState<any>();

    useEffect(() => {
        const groupedValue = assetItemStatusTemp?.taskDetails?.fleetRequestTaskListTrackings?.reduce((acc: any[], cur: any) => {
            let obj: any = {}
            obj.Step = cur.step
            obj.StepId = cur?.stepId
            obj.Details = []
            let detailsTemp = assetItemStatusTemp?.taskDetails?.fleetRequestTaskListTrackings?.filter((item: any) => item.stepId == cur?.stepId)
            if (detailsTemp?.length) {
                detailsTemp?.map((detailItem: any, _index: any) => {
                    obj.Details = obj.Details.concat(detailItem)
                })
            }
            if (acc.find((itemval: any) => itemval.StepId == cur.stepId)) {
                return acc;
            }
            acc = acc.concat(obj);
            return acc;
        }, []);

        setAssetItemStatusTaskDetail(groupedValue)
    }, [assetItemStatusTemp?.taskDetails])

    const iconReturn = (status: any) => {
        let src = "";
        switch (status) {
            case "Completed":
                src = CompletedIcon;
                break;
            case "Up Next":
                src = UpNextIcon;
                break;
            case "Delayed":
                src = DelayedIcon;
                break;
            case "Not Started":
                src = NotStartedIcon;
                break;
            case "N/A":
                src = NA;
                break;
            case "Pending":
                src = pendingIcon;
                break;
            default:
                break;
        }
        return <><img src={src} alt="Error Image" className="error-image" /></>;
    }

    return (
        <div className="task-bulkorderfleet p-3">
             <LoadingWrapper isLoading={isLoading} data-attribute="Task_Default_LoadingWrapper"> 
            {
                assetItemStatusTaskDetailTemp?.map((item?: any) => {
                    return (<div className="taskList-bulkorderfleet">
                        <p className="group-heading"><b>{item?.Step}</b></p>
                        {
                            item?.Details.map((subItem: any) => {
                                return (
                                    <div className="group-content">
                                        <p className="group-subheading">{subItem.taskDescription}</p>
                                        <p className="group-status">
                                            {iconReturn(subItem.taskStatus)}
                                            {(subItem.taskStatus == CONSTANTS?.ORDER_STATUS?.COMPLETED || (subItem.taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS.INVOICE_PAID && subItem.taskStatus == "Delayed"))  ? Moment(subItem?.completedOn).format('MM/DD/YYYY') : subItem.taskStatus}
                                        </p>
                                    </div>
                                )
                            })
                        }
                    </div>)
                })
            }
            </LoadingWrapper>
        </div>
    )
}
export default Task